<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'configuracion'}">{{$t("configuracion")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'proveedores', params:{idBusiness: idBusiness}}">
                                {{$t("proveedores")}}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{action}} {{$t("proveedor")}}</li>
                    </ol>
                </nav>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="tituloNumier"><i class="fa fa-building"></i> {{nombreNegocio}}</h2>
                            <hr>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <router-link v-if="!desdeSubproducto"
                                             :to="{name:'categoria', params:{'idBusiness':idBusiness,'desdeProveedor':1,'idProveedor':idProveedor}}">
                                    <span style=" font-size: small;color: #0976b4; float: right">{{$t("nuevaCategoria")}}</span>
                                </router-link>
                                <label><strong>{{$t("category")}}</strong></label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="proveedor.idCategory"
                                           filterable
                                           :placeholder="$t('seleccionaCategoria')">
                                    <el-option v-for="category in listCategory"
                                               class="select-primary"
                                               :value="category.id"
                                               :label="category.name"
                                               :key="category.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-8">
                            <div class="form-group">
                                <label for="nameCasa"><strong>{{$t("nombreProveedor")}} <span style="color: red">*</span></strong></label>
                                <input type="text" class="form-control"
                                       :class="{'is-valid': proveedor.name.length >0 && proveedor.name.length <= maxNameProveedor,
                                       'is-invalid': proveedor.name.length > maxNameProveedor}"
                                       id="nameCasa" v-bind:placeholder="$t('introduzcaNombre')"
                                       v-model="proveedor.name" ref="name">
                                <input type="hidden" v-model="proveedor.xname">
                                <small class="form-text text-muted">{{proveedor.name.length}}/50</small>
                            </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cifnifproveedor"><strong>{{$t("cifNif")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cifnifproveedor" v-bind:placeholder="$t('introduzcaCifNif')"
                                       v-model="proveedor.cifnif">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="addressproveedor"><strong>{{$t("direccion")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="addressproveedor" v-bind:placeholder="$t('introduzcaDireccion')"
                                       v-model="proveedor.address">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="provinceCasa"><strong>{{$t("provincia")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="provinceCasa" v-bind:placeholder="$t('introduzcaProvincia')"
                                       v-model="proveedor.province">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cityCasa"><strong>{{$t("ciudad")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cityCasa" v-bind:placeholder="$t('introduzcaCiudad')"
                                       v-model="proveedor.city">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="cpCasa"><strong>{{$t("codigoPostal")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="cpCasa" v-bind:placeholder="$t('introduzcaCodigoPostal')"
                                       v-model="proveedor.cp">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phoneCasa"><strong>{{$t("telefono")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="phoneCasa" v-bind:placeholder="$t('introduzcaTelefono')"
                                       v-model="proveedor.phone">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="emailCasa"><strong>{{$t("correoElectronico")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="emailCasa" v-bind:placeholder="$t('introduzcaCorreo')"
                                       v-model="proveedor.email">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="ibanProveedor"><strong>{{$t("iban")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="ibanProveedor" v-bind:placeholder="$t('introduzcaIban')"
                                       v-model="proveedor.iban">
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="numeroRegistroSanitarioProveedor"><strong>{{$t("numeroRegistroSanitario")}}</strong></label>
                                <input type="text" class="form-control"
                                       id="numeroRegistroSanitarioProveedor" v-bind:placeholder="$t('introduzcaNumeroRegistroSanitario')"
                                       v-model="proveedor.numeroRegistroSanitario">
                            </div>
                        </div>
                        <br>

                        <div class="col-md-4" v-if="tieneSage">
                                <div class="form-group" >
                                    <label><strong>{{$t('cuentaContableGastos')}}</strong></label>
                                    <el-select class="select-default select-account"
                                        v-model="proveedor.idCuenta" filterable :placeholder="$t('seleccioneUnaCuenta')">
                                            <el-option v-for="cuenta in listCuentasProveedores"
                                                class="select-primary select-account"
                                                :value="cuenta.id"
                                                :label="cuenta.codigoCuenta+cuenta.codigoSubCuenta+' - '+cuenta.nombreCuenta"
                                                :key="cuenta.id">
                                                </el-option>
                                        </el-select>
                                </div>
                        </div>

                        <div class="col-md-4" v-if="tieneSage">
                                <div class="form-group" >
                                    <label><strong>{{$t('cuentaContableApuntes')}}</strong></label>
                                    <el-select class="select-default select-account"
                                        v-model="proveedor.idCuentaApunte" filterable :placeholder="$t('seleccioneUnaCuenta')">
                                            <el-option v-for="cuenta in listCuentasApuntes"
                                                class="select-primary select-account"
                                                :value="cuenta.id"
                                                :label="cuenta.codigoCuenta+cuenta.codigoSubCuenta+' - '+cuenta.nombreCuenta"
                                                :key="cuenta.id">
                                                </el-option>
                                        </el-select>
                                </div>
                        </div>

                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("acreedor")}}</strong>
                                    </label>
                                    <el-switch v-model="proveedor.acreedor"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>

                                    <span style="font-size: small">{{$t("infoAcreedor")}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="form-group">
                                    <label>
                                        <strong>{{$t("baja")}}</strong>
                                    </label>
                                    <el-switch v-model="proveedor.baja"
                                               active-color="#13ce66"
                                               inactive-color="#bcbcbc">
                                    </el-switch>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-primary" v-once-click.once="saveProveedor" :disabled="inProgress"><i
                                    class="fa fa-check-square"></i> {{$t("guardar")}}
                            </button>
                            <router-link :to="{name:'proveedores', params:{idBusiness: idBusiness, 'pag' : pag}}">
                                <button class="btn btn-danger"><i class="fa fa-window-close"></i> {{$t("cancelar")}}
                                </button>
                            </router-link>
                            <el-checkbox v-model="checkReply" border class="checkbox-element">
                                {{$t("replicar")}}
                            </el-checkbox>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="modalReply" :adaptive=true :scrollable=true height="auto"  :clickToClose=false>
            <div>
                <div class="modal-header">
                    <h4 style="margin: 0px">{{$t("replicarProveedor")}}</h4>
                </div>
                <div class="modal-body">
                    <input type="checkbox" id="checkSelectAll" name="checkSelectAll" v-model="checkSelectAll"
                           @click="selectAll">
                    <label for="checkSelectAll" class="checkSelectAll">{{$t("seleccionarTodos")}}</label>

                    <div v-for="business in listBusinesses">
                        <el-checkbox v-if="business.id != idBusiness" v-model="business.checked" border
                                     class="checkbox-element" style="width: 100%">
                            {{business.establishmentName}}
                        </el-checkbox>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="closeModal()"><i
                            class="fa fa-times-circle"></i> {{$t("cancelar")}}
                    </button>
                    <button class="btn btn-primary" @click="replyProveedor"><i class="fa fa-check-circle"></i>
                        {{$t("aceptar")}}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import swal from 'sweetalert2';
    import {Loading} from 'element-ui';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        Switch
    } from 'element-ui'


    export default {
        props: ['idBusiness', 'idProveedor', 'pag', 'ultimaCategoria', 'desdeSubproducto', 'idSubproducto'],
        created() {
            this.action = this.idProveedor ? this.$i18n.t("editar") : this.$i18n.t("nuevo");

            this.loadingGeneral = Loading.service({text: this.$t('cargando')});
            this.getIdTpvByBusiness();
            this.identificacionNegocio();
            this.getCategory();


            if (this.idProveedor) {
                this.getProveedor();
            }

        },
        updated() {

            this.nPeticiones++;

            if (this.idProveedor) {
                if (this.nPeticiones === 3) {
                    this.loadingGeneral.close();
                }

            } else {
                if (this.nPeticiones === 2) {
                    this.loadingGeneral.close();
                }
            }

        },

        components: {
            [Checkbox.name]: Checkbox,
            [Switch.name]: Switch,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        mounted() {
            this.$refs.name.focus();
        },
        data() {
            return {
                loadingGeneral: null,
                nPeticiones: 0,

                proveedor: {
                    name: "",
                    xname: "",
                    cifnif: "",
                    address: "",
                    province: "",
                    city: "",
                    cp: "",
                    phone: "",
                    email: "",
                    iban: "",
                    numeroRegistroSanitario: "",
                    acreedor: false,
                    idCategory: 0,
                    baja: false,
                    idCuenta: "0",
                    idCuentaApunte: "0",
                    iban: "",
                    numeroRegistroSanitario: ""
                },
                nombreNegocio: "",
                checkSelectAll: false,
                listBusinesses: [],
                listCategory: [],
                checkReply: false,
                maxNameProveedor: 50,
                action: "",
                inProgress: false,
                idTpv: "",
                listCuentasProveedores: [],
                listCuentasApuntes: [],
                tieneSage: false
            }
        },
        methods: {
            checkCampos() {
                if (this.proveedor.name.length > this.maxNameProveedor) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('laLongitudDelNombreNoPuedeSerMayorDe') + this.maxNameProveedor + '.',
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else if (this.proveedor.name === null || this.proveedor.name.length === 0) {
                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('relleneTodosLosDatosMarcadosConAsteriscoAntesDeEnviar'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });
                    return false;
                } else {
                    return true;
                }
            },
            identificacionNegocio() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'general/identifyBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.nombreNegocio = response.data.result

                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            //Consigo el idTpv que me hace falta para cargar las cuentas
            getIdTpvByBusiness() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                }; 

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getTpvIdByBusiness", config)
                    .then(function (response) {

                        vm.idTpv = response.data;
                        vm.cargarCuentasPorIdTpv();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            //Cargo las cuentas de tipo proveedor
            cargarCuentasPorIdTpv() {
                var config = {
                    params: {
                        idTpv: this.idTpv,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "importacion/getSuppliersBusinessDataByIdTpv", config)
                    .then(function (response) {
                        
                        if (response.data.response) {
                            if (response.data.result.length >= 1) {
                                vm.tieneSage = true;
                            }

                            vm.listCuentasProveedores.push({id:"0", codigoCuenta: "0", codigoSubCuenta: "", nombreCuenta: vm.$t('sinCuentaAsociada')});
                            vm.listCuentasApuntes.push({id:"0", codigoCuenta: "0", codigoSubCuenta: "", nombreCuenta: vm.$t('sinCuentaAsociada')});
                            response.data.result.forEach(cuenta => {
                                if(cuenta.tipo == 'P') {
                                    vm.listCuentasProveedores.push(cuenta);
                                } else if (cuenta.tipo == 'A') {
                                    vm.listCuentasApuntes.push(cuenta);
                                }
                            })
                            //vm.listCuentasSage = response.data.result;
                            
                            vm.respuesta = true;

                        }
                        vm.loading = false;


                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getProveedor() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idSupplier: this.idProveedor,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'suppliers/getSupplierById', config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.proveedor = response.data.result;
                            vm.proveedor.xname = response.data.result.name
                            if (vm.ultimaCategoria) {
                                vm.proveedor.idCategory = vm.ultimaCategoria;
                            }
                            ;

                        } else {    
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },
            getCategory() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + 'suppliers/getTagsByBusiness', config)
                    .then(function (response) {
                        if (response.data.response) {


                            if (response.data.result.length === 0) {

                                let category = {
                                    name: vm.$t('sinCategoria'),
                                    id: 0
                                };

                                vm.listCategory.push(category);

                            }

                            for (let i = 0; i < response.data.result.length; i++) {

                                if (i === 0) {

                                    let category = {
                                        name: vm.$t('sinCategoria'),
                                        id: 0
                                    };

                                    vm.listCategory.push(category);

                                }

                                let categoryname = {
                                    name: response.data.result[i].name,
                                    id: response.data.result[i].id,
                                };

                                vm.listCategory.push(categoryname)

                            }


                            if (vm.ultimaCategoria) {
                                vm.proveedor.idCategory = vm.ultimaCategoria;
                            }

                        } else {
                            swal({
                                title: vm.$t('sinCategoria'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }

                    });
            },

            saveProveedor() {
                if (this.checkCampos()) {
                    this.inProgress = true;

                    var config = {
                        params:{
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };
                    var params = {
                        idBusiness: this.idBusiness,
                        supplier: this.proveedor,
                        jwt: this.$store.getters.jwt
                    };

                    let vm = this;
                    let controller = this.idProveedor ? "editSupplierById" : "newSupplierByBusiness";
                    this.axios.post(this.$store.getters.apiUrl + 'suppliers/' + controller, params, config)
                        .then(function (response) {
                            vm.inProgress = false;

                            if (response.data.response) {
                                let notify = vm.idProveedor ? vm.$t('actualizada') : vm.$t('creada');
                                vm.$notify({
                                    message: vm.$t('proveedor') + ' ' + notify + ' '+ vm.$t('correctamente'),
                                    icon: 'nc-icon nc-check-2',
                                    timeout: 2000,
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'success'
                                });

                                if (vm.checkReply) {

                                    if (!vm.idProveedor) {
                                        vm.proveedor.xname = vm.proveedor.name;
                                    }

                                    vm.axios.get(vm.$store.getters.apiUrl + 'general/getBusinessesByUserReplicado', config)
                                        .then(function (response) {
                                            if (response.data.response) {
                                                vm.listBusinesses = response.data.result;
                                                vm.$modal.show('modalReply');
                                            } else {
                                                swal({
                                                    title: vm.$t('atencion'),
                                                    text: response.data.message,
                                                    confirmButtonClass: 'btn btn-info btn-fill',
                                                    type: 'error'
                                                });
                                            }

                                        });

                                } else {
                                    if (!vm.desdeSubproducto) {

                                        vm.$router.push({
                                            name: 'proveedores',
                                            params: {idBusiness: vm.idBusiness, 'pag': vm.pag}
                                        })
                                    }
                                    else {


                                        vm.$router.push({
                                            name: 'subproducto',
                                            params: {
                                                idBusiness: vm.idBusiness,
                                                idSubproducto: vm.idSubproducto,
                                                'ultimoProveedor': response.data.result,
                                                'pag': vm.pag
                                            }
                                        })

                                    }
                                }

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        }).catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
                }
            },


            replyProveedor() {
                var config = {
                    params:{
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                let xbusinesses = new Array();
                this.listBusinesses.forEach(function (business) {
                    if (business.checked && business.id!==vm.idBusiness) {
                        xbusinesses.push(business);
                    }

                });

                var params = {
                    idBusiness: this.idBusiness,
                    listBusinesses: xbusinesses,
                    supplier: this.proveedor,
                    jwt: this.$store.getters.jwt
                };
                this.axios.post(this.$store.getters.apiUrl + 'suppliers/replySupplier', params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.closeModal();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });


                        }
                    }).catch(function (error) {
                    console.log(error);
                    vm.inProgress = false;
                });
            },
            closeModal() {
                this.$modal.hide('modalReply');
                this.$router.push({name: 'proveedores', params: {idBusiness: this.idBusiness, 'pag': this.pag}})
            },
            selectAll() {
                if (this.checkSelectAll) {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = false;
                    });
                } else {
                    this.listBusinesses.forEach(function (business) {
                        business.checked = true;
                    });
                }
            }
        }

    }
</script>

<style scoped>

    .card {
        padding: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Widgets/Proveedores/ProveedorForm.vue